import { fetchAPI, assertUpstreamOk } from '../../lib/api';
import settings from '../../settings.json';
import { default as WrappedArticle } from '../../components/custom/article';
import { uid } from 'react-uid';
import { purgeNextjs404Files } from "../../lib/purgeNextjs404Files";

const Article = ({ categories, topics, article, is404 }) => {
  return <WrappedArticle categories={categories} topics={topics} article={article} key={uid(article)} is404={is404} />;
};

export async function getStaticPaths() {
  let is404 = false;

  const articlesRes = await fetchAPI('/articles', { fields: ['slug'] }).catch(() => {
    is404 = true;
    return null;
  });

  return {
    paths: is404
      ? []
      : articlesRes?.data?.map((article) => ({
        params: {
          slug: article.attributes.slug,
        },
      })) ?? [],
    fallback: settings.useFallbackPaths ?? false,
  };
}

export async function getStaticProps({ params, preview }) {
  const [articlesRes, categoriesRes, topicsRes] = await Promise.all([
    fetchAPI('/articles', {
      filters: {
        slug: params.slug,
      },
      populateDeep: true,
      sort: { rank: 'asc' },
      status: preview ? 'draft' : 'published',
    }),
    fetchAPI('/categories', {
      populateDeep: true,
      sort: { rank: 'asc' },
      status: preview ? 'draft' : 'published',
    }),
    fetchAPI('/topics', {
      populateDeep: true,
      sort: { rank: 'asc' },
      pagination: {
        pageSize: 100,
      },
      status: preview ? 'draft' : 'published',
    }),
  ]);

  assertUpstreamOk([articlesRes, categoriesRes, topicsRes], `artikel ${params.slug}`);

  const is404 = articlesRes?.data[0] ? false : true;
  if (is404) {
    await purgeNextjs404Files(['artikel', params.slug]);
  }

  return {
    props: {
      categories: categoriesRes?.data ?? [],
      topics: topicsRes?.data ?? [],
      article: articlesRes?.data[0] ?? {},
      is404: is404
    },
    revalidate: is404 && !settings.prodMode ? undefined : settings.cacheRefreshSeconds,
    notFound: is404,
  };
}

export default Article;
